import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import Logo from "@/components/Logo";
import { Star, ArrowRight, Users, Flame, MapPin } from "lucide-react";

const features = [
  {
    icon: <MapPin className="h-8 w-8 text-sauna-orange" />, 
    title: "Discover Local Wellness",
    description: "Find the best sauna and cold plunge spots near you, curated for wellness seekers.",
  },
  {
    icon: <Flame className="h-8 w-8 text-sauna-orange" />, 
    title: "Hot & Cold Therapy",
    description: "Experience the benefits of contrast therapy for mind and body rejuvenation.",
  },
  {
    icon: <Users className="h-8 w-8 text-sauna-orange" />, 
    title: "Join the Community",
    description: "Connect with other enthusiasts and share your wellness journey.",
  },
];

const testimonials = [
  {
    quote: "This platform changed how I discover wellness spots! Can't wait for the full launch.",
    name: "Alex P.",
    rating: 5,
  },
  {
    quote: "A must-have for anyone into saunas and cold plunges.",
    name: "Jamie L.",
    rating: 5,
  },
];

const TempMarketingLandingPage: React.FC = () => {
  return (
    <>
      <Navbar />
      <main className="bg-gradient-to-br from-sauna-beige via-white to-sauna-beige min-h-screen py-16">
        {/* Hero Section */}
        <section className="max-w-5xl mx-auto px-4 flex flex-col items-center text-center py-16">
          <Logo size="md" className="mb-8" />
          <h1 className="text-5xl font-bold text-sauna-navy mb-6">Wellness, Reimagined</h1>
          <p className="text-xl text-sauna-navy/80 mb-8 max-w-2xl">Discover, connect, and immerse yourself in the best sauna and cold plunge experiences. Join our community and elevate your wellness journey.</p>
          <Button className="bg-sauna-orange hover:bg-sauna-orange/90 text-white px-8 py-4 rounded-full text-lg mb-4" asChild>
            <a href="/choose-signup">Get Early Access <ArrowRight className="ml-2" /></a>
          </Button>
        </section>
        {/* Features Section */}
        <section className="max-w-5xl mx-auto px-4 py-12 grid md:grid-cols-3 gap-8">
          {features.map((feature, idx) => (
            <Card key={idx} className="border-none shadow-md hover:shadow-lg transition-shadow">
              <CardContent className="pt-6 flex flex-col items-center text-center">
                <div className="mb-4">{feature.icon}</div>
                <h3 className="text-xl font-semibold mb-2 text-sauna-navy">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
              </CardContent>
            </Card>
          ))}
        </section>
        {/* Testimonials Section */}
        <section className="max-w-5xl mx-auto px-4 py-12">
          <h2 className="text-3xl font-bold text-sauna-navy mb-8 text-center">What Early Users Say</h2>
          <div className="grid md:grid-cols-2 gap-8">
            {testimonials.map((testimonial, idx) => (
              <Card key={idx} className="bg-white border-none shadow-md">
                <CardContent className="p-6 flex flex-col items-center text-center">
                  <div className="flex mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} className="w-5 h-5 fill-sauna-orange text-sauna-orange" />
                    ))}
                  </div>
                  <p className="italic mb-4 text-gray-800">"{testimonial.quote}"</p>
                  <p className="font-semibold">{testimonial.name}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </section>
        {/* CTA Section */}
        <section className="max-w-5xl mx-auto px-4 py-12 text-center">
          <h2 className="text-3xl font-bold text-sauna-navy mb-6">Ready to Join the Wellness Movement?</h2>
          <Button className="bg-sauna-orange hover:bg-sauna-orange/90 text-white px-8 py-4 rounded-full text-lg" asChild>
            <a href="/choose-signup">Get Early Access <ArrowRight className="ml-2" /></a>
          </Button>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default TempMarketingLandingPage; 